import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

import { Component, computed } from "vue"

interface Props {
    text: string
    icon: Component
    disabled?: boolean
    iconClass?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsTooltip',
  props: {
    text: {},
    icon: {},
    disabled: { type: Boolean },
    iconClass: {}
  },
  emits: ["onButtonClick"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const tooltipStyle = computed(() => "font-medium text-xs  px-3 py-2")

function onButtonClick() {
    emit("onButtonClick")
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createBlock(_component_Button, {
    type: "button",
    class: "p-0 bg-transparent border border-transparent",
    disabled: _ctx.disabled,
    onClick: onButtonClick
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), {
        class: _normalizeClass(['w-5 h-5 stroke-gray-400 hover:stroke-gray-500', _ctx.iconClass]),
        "aria-hidden": "true"
      }, null, 8, ["class"]))
    ]),
    _: 1
  }, 8, ["disabled"])), [
    [
      _directive_tooltip,
      { value: _ctx.text, class: `${tooltipStyle.value}` },
      void 0,
      { top: true }
    ]
  ])
}
}

})